/**
 * Service pour les opérations sur les quote attempts
 */

import { api, endpoints } from './api.js'

export const quoteAttemptsService = {
  getAnalytics: (params = {}) => {
    const queryString = new URLSearchParams(params).toString()
    const url = queryString ? `${endpoints.quoteAttempts.analytics()}?${queryString}` : endpoints.quoteAttempts.analytics()
    return api.get(url)
  },

  list: (params = {}) => {
    const queryString = new URLSearchParams(params).toString()
    const url = queryString ? `${endpoints.quoteAttempts.list()}?${queryString}` : endpoints.quoteAttempts.list()
    return api.get(url)
  },

  detail: (id) => api.get(endpoints.quoteAttempts.detail(id))
}
